import {
  useScheduleProductionRequirements,
  useSchedulerTableHandlers,
} from './Scheduler.data'
import { SchedulerKitchenCycleRowType } from './Scheduler.types'
import { SchedulerKitchenCyclesTable } from './SchedulerKitchenCycles.muiTable'
import { KitchenCycleEditor } from './KitchenCycleEditor'
import { Box } from '@mui/material'

type Props = { schedulerId: string; iteration: string }

const API = 'kitchen-cycles'

/** Kitchen cycles in a schedule's Raw Data. See `KitchenCycleEditor`. */
export const ScheduleKitchenCyclesView = ({
  schedulerId,
  iteration,
}: Props) => {
  const {
    data: cycleResponse = { data: [], predicate: undefined },
    isLoading,
  } = useScheduleProductionRequirements(schedulerId, API, iteration)
  const cycleRows = (cycleResponse.data ?? []) as SchedulerKitchenCycleRowType[]
  const { data: routesResponse = { data: [] } } =
    useScheduleProductionRequirements(schedulerId, 'packing-routes', iteration)
  const { data: tanksResponse = { data: [] } } =
    useScheduleProductionRequirements(schedulerId, 'tanks', iteration)
  const handlers = useSchedulerTableHandlers<SchedulerKitchenCycleRowType>(
    schedulerId,
    API,
    iteration
  )

  return (
    <Box>
      <KitchenCycleEditor
        cycleRows={cycleRows}
        routes={routesResponse.data ?? []}
        tanks={tanksResponse.data ?? []}
        onSave={handlers.updateTableData}
        onDelete={handlers.deleteTableData}
        isBusy={handlers.isSaving || handlers.isDeleting}
      />
      <SchedulerKitchenCyclesTable
        data={cycleRows}
        isLoading={isLoading}
        updateTableData={handlers.updateTableData}
        uploadScheduleData={handlers.uploadScheduleData}
        isUploading={handlers.isUploading}
        isSaving={handlers.isSaving}
        updateRowsStatus={handlers.updateRowsStatus}
        predicate={cycleResponse.predicate}
        deleteTableData={handlers.deleteTableData}
        isDeleting={handlers.isDeleting}
      />
    </Box>
  )
}
